import { render } from "./CampaignFilterBody.vue?vue&type=template&id=72ec57c4"
import script from "./CampaignFilterBody.vue?vue&type=script&lang=js"
export * from "./CampaignFilterBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__